import { promiseActionFactory } from "@teroneko/redux-saga-promise";

import { createActionTypes } from "utils/store";
import { ISettingsData } from 'types/settings.types';

const SETTINGS_ACTIONS = {
  LOAD_SETTINGS: 'LOAD_SETTINGS',
  UPDATE_SETTINGS: 'UPDATE_SETTINGS',
};

const actionTypes = createActionTypes('settings', SETTINGS_ACTIONS);

export const loadSettingsAction = promiseActionFactory<ISettingsData>().create(actionTypes.LOAD_SETTINGS);
export const updateSettingsAction = promiseActionFactory<ISettingsData>().create<{ data: ISettingsData }>(actionTypes.UPDATE_SETTINGS);
